<template lang="pug">
    section#banner
        img(:src="image", :alt="titulo")
</template>

<script>
export default {
    name: "section-banner",
    props: {
        image: String,
        titulo: String
    }
}
</script>

<style lang="stylus" scoped src="./Banner.styl"></style>